import { render, staticRenderFns } from "./photoClassifyMenu.vue?vue&type=template&id=f4a2d1a2&scoped=true&"
import script from "./photoClassifyMenu.vue?vue&type=script&lang=js&"
export * from "./photoClassifyMenu.vue?vue&type=script&lang=js&"
import style0 from "./photoClassifyMenu.vue?vue&type=style&index=0&id=f4a2d1a2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4a2d1a2",
  null
  
)

export default component.exports